module.exports = __webpack_public_path__ + "img/图banner.eb8f5208.jpg";